import { getFontStyles } from '@ycos/primitives'
import napStyles from './../napRtl.json'

const preTitle = {
  ...getFontStyles(napStyles, { type: 'Heading', name: 'A1' }),
  fontWeight: 'normal',
  fontSizeSmall: '14px',
  fontSizeMedium: '16px',
  lineHeightSmall: '22px',
  lineHeightMedium: '24px'
}

const title = {
  ...getFontStyles(napStyles, { type: 'Heading', name: 'B7' }),
  fontSizeSmall: '24px',
  fontSizeMedium: '32px',
  lineHeightSmall: '32px',
  lineHeightMedium: '40px',
  widthSmall: '270px',
  widthMedium: '411px'
}

const textStyles = {
  name: '3',
  type: 'Paragraph'
}

export default {
  preTitle,
  title,
  textStyles
}
